// Subject palette mirror of /app/backend/design_system.py so the planner
// cells, badges, and color-pickers stay consistent with the PDFs/exports.
// We normalise both "Science & Technology" and "Science and Technology"
// because the frontend options + backend payloads use slightly different
// labels in different places.

const PALETTE = {
  Mathematics: "#1f628e",
  "Science and Technology": "#2e7d4f",
  "Science & Technology": "#2e7d4f",
  Language: "#eeba2b",
  "Social Studies": "#bb5759",
  History: "#bb5759",
  Geography: "#91b2eb",
  "The Arts": "#75d481",
  Dance: "#4fb0a0",
  Drama: "#b06fb0",
  Music: "#e0568f",
  "Visual Arts": "#e59a3c",
  "Health and Physical Education": "#de0f3f",
  "Health & Physical Education": "#de0f3f",
  Health: "#de0f3f",
  "Physical Education": "#e8683f",
  "French as a Second Language": "#5a3b8e",
  "French (Prep)": "#5a3b8e",
  "Music (Prep)": "#e0568f",
  Prep: "#9aa7b3",
  "DPA / Flex": "#7a8aa0",
};

export const DEFAULT_SUBJECT_COLOR = "#96ded1";

export const subjectColor = (subject) => {
  if (!subject) return DEFAULT_SUBJECT_COLOR;
  const trimmed = String(subject).trim();
  if (PALETTE[trimmed]) return PALETTE[trimmed];
  // Soft fuzzy fallback — handle "Mathematics (Prep)" style variants
  const lower = trimmed.toLowerCase();
  for (const [name, hex] of Object.entries(PALETTE)) {
    if (lower.includes(name.toLowerCase())) return hex;
  }
  return DEFAULT_SUBJECT_COLOR;
};

// Convert "#RRGGBB" to a soft 12% tint suitable for cell backgrounds.
export const tint = (hex, alpha = 0.15) => {
  const h = (hex || "#96ded1").replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const blend = (c) => Math.round(255 - (255 - c) * alpha);
  return `rgb(${blend(r)}, ${blend(g)}, ${blend(b)})`;
};

export const SUBJECT_OPTIONS_PLUS_PREP = [
  "Mathematics",
  "Language",
  "Science and Technology",
  "Social Studies",
  "History",
  "Geography",
  "Dance",
  "Drama",
  "Music",
  "Visual Arts",
  "Health",
  "Physical Education",
  "French as a Second Language",
  "Prep",
  "DPA / Flex",
];
